module.exports = __webpack_public_path__ + "static/img/1-2.1e45687.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/1-2.png
// module id = 6Sra
// module chunks = 0